"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 14 8" id=icon-chevron-down-small><path d="M13.71.294a1 1 0 00-1.41 0L7.002 5.59 1.713.294A1.004 1.004 0 00.294 1.713l5.998 5.996a1 1 0 001.41 0l5.997-5.996a1 1 0 00.01-1.42z"></path></symbol>';
};